import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { WelcomeMessageProps } from '../../interfaces/WelcomeMessage.interface';
import { getSalutationContent } from '../../store/contentSlice';

const WelcomeMessage = ({ firstName }: WelcomeMessageProps): ReactElement => {
  const { welcomeMessage }: any = useSelector(getSalutationContent);

  return (
    <div className="welcome-msg" data-testid="welcome-msg">
      {welcomeMessage}
      {firstName && <div className="user-name">{firstName}</div>}
    </div>
  );
};

export default WelcomeMessage;
